import { API } from '../../shared/apiRoutes'
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { BulkDeleteRes, CheckExistenceRes, DiscountListRes, ExistenceProps, PayloadProps, UpdateRes, updateStatusType, DiscountTypeRes, PropertyResponse, GetDiscountDetails, CustomerResponse, CustomerGroupResponse, RoleBasedResponse, SaveDiscountRes, UpdateDiscountRes, DiscountDataProps } from "../../components/discounts/manualDiscount/manualDiscountModule";
import { ZenToast } from 'zen-core-elements';


interface initialData {
    loading: boolean,
    discountList: { value: DiscountDataProps[], count: number, loading: boolean },
    bulkDeleteResponse: BulkDeleteRes | null,
    deleteResponse: UpdateRes | null,
    error: string,
    checkDuplicate: { error: string, loading: boolean, value: CheckExistenceRes | null }
    discountType: DiscountTypeRes | null,
    getProperty: { loading: boolean, error: string, value: PropertyResponse | null }
    getOneDiscount: { loading: boolean, error: string, value: GetDiscountDetails | null }
    getCustomer: { loading: boolean, error: string, value: CustomerResponse | null },
    getCustomerGroup: { loading: boolean, error: string, value: CustomerGroupResponse | null }
    getRoleBased: { loading: boolean, error: string, value: RoleBasedResponse | null },
    addDiscount: { loading: boolean, error: string, value: SaveDiscountRes | null },
    updateDiscount: { loading: boolean, error: string, value: UpdateDiscountRes | null }
}

interface discountDeleteProps {
    storeId: number,
    data: updateStatusType,
    id: number
}
interface discountProps {
    storeId: number,
    data: PayloadProps | undefined
}
interface bulkDeleteProps {
    storeId: number,
    selectedItems: number[]
}

interface checkDuplicateProps {
    storeId: number,
    data: ExistenceProps
}

//initial State
const initialState: initialData = {
    loading: false,
    discountList: { value: [], count: 0, loading: false },
    bulkDeleteResponse: null,
    deleteResponse: null,
    error: '',
    checkDuplicate: { error: '', loading: true, value: null },
    discountType: null,
    getProperty: { loading: true, error: '', value: null },
    getOneDiscount: { loading: true, error: '', value: null },
    getCustomer: { loading: true, error: '', value: null },
    getCustomerGroup: { loading: true, error: '', value: null },
    getRoleBased: { loading: true, error: '', value: null },
    addDiscount: { loading: true, error: '', value: null },
    updateDiscount: { loading: true, error: '', value: null }
}

//getAllPosManual discount call
export const getAllPosDiscountList = createAsyncThunk('manualDiscount/getAllPosDiscountList', ({ storeId, data }: discountProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllPosDiscount, { storeId: storeId })
    return HttpRoutingService?.getMethod<DiscountListRes>(url, data)
})
//bulk delete discount list
export const bulkDeleteDiscountData = createAsyncThunk('manualDiscount/bulkDeleteDiscountData', ({ storeId, selectedItems }: bulkDeleteProps) => {
    const url = HttpRoutingService.replaceUrl(API.bulkDeleteDiscount, { storeId: storeId })
    return HttpRoutingService.postMethod<BulkDeleteRes>(url, { id: selectedItems })
})
//single delete discount list
export const singleDeleteData = createAsyncThunk('manualDiscount/singleDeleteData', ({ storeId, data, id }: discountDeleteProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateDiscountStatus, { storeId: storeId, id: id })
    return HttpRoutingService?.deleteMethod<UpdateRes>(url, data)
})
//check duplicate promo code existence call
export const checkDuplicatesData = createAsyncThunk("manualDiscount/checkDuplicatesData", ({ storeId, data }: checkDuplicateProps) => {
    const url = HttpRoutingService?.replaceUrl("stores/{storeId}/discounts/existence", { storeId: storeId })
    return HttpRoutingService?.getMethod<CheckExistenceRes>(url, data, "v1/")
})
//activate/deactivate discount list
export const updateDiscountListStatus = createAsyncThunk("manualDiscount/updateDiscountStatus", ({ storeId, data, id }: discountDeleteProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateDiscountStatus, { storeId: storeId, id: id })
    return HttpRoutingService?.putMethod<UpdateRes>(url, data)
})
//fetch discount types
export const getPosDiscountTypes = createAsyncThunk("manualDiscount/getPosDiscountTypes", ({ storeId }: { storeId: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getDiscountTypes, { storeId: storeId })
    return HttpRoutingService?.getMethod<DiscountTypeRes>(url)
})
//getProperty values
export const getPosPropertyValueData = createAsyncThunk("manualDiscount/getPosPropertyValueData", ({ storeId, propertyValues }: { storeId: number, propertyValues: string[] }) => {
    return HttpRoutingService.getMethod<PropertyResponse>('properties/code', { code: JSON.stringify(propertyValues), storeId: storeId });
})
//getONe discount details
export const getOnePosDiscountData = createAsyncThunk("manualDiscount/getOnePosDiscountData", ({ storeId, discountId }: { storeId: number, discountId: number | undefined }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOneDiscount, { storeId: storeId, id: discountId })
    return HttpRoutingService?.getMethod<GetDiscountDetails>(url)
})

export const getCustomerEligibilityTypeData = createAsyncThunk("manualDiscount/getCustomerEligibilityTypeData", ({ storeId, data, url, apiVersion = "v2" }: { storeId: number, data: any, url: string, apiVersion?: "v1" | "v2" }) => {
    const finalUrl = HttpRoutingService.replaceUrl(url, { storeId: storeId })
    return HttpRoutingService.getMethod<CustomerResponse & CustomerGroupResponse & RoleBasedResponse>(finalUrl, data, `${apiVersion}/`)
})

//add disocunt
export const addPosDiscount = createAsyncThunk("manualDiscount/addPosDiscount", ({ storeId, data }: { storeId: number, data: any }) => {
    const url = HttpRoutingService.replaceUrl(API.addDiscount, { storeId: storeId })
    return HttpRoutingService.postMethod<SaveDiscountRes>(url, data)
})
//update discount
export const updatePosDiscount = createAsyncThunk("manualDiscount/updatePosDiscount", ({ storeId, data, id }: { storeId: number, data: any, id: number }) => {
    const url = HttpRoutingService.replaceUrl(API.getOneDiscount, { storeId: storeId, id: id })
    return HttpRoutingService.putMethod<UpdateDiscountRes>(url, data)
})


export const ManualDiscountSlice = createSlice({
    name: 'manualDiscount',
    initialState: initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder.addCase(getAllPosDiscountList?.pending, (state) => {
            state.discountList.loading = true;
        })
        builder.addCase(getAllPosDiscountList?.fulfilled, (state, action) => {
            const offset = action?.meta?.arg?.data?.offset || 0;
            const rows = action?.payload?.discountList?.rows || [];
            if (offset > 0) {
                state.discountList.value = [...state.discountList.value, ...rows];
            } else {
                state.discountList.value = rows;
            }
            state.discountList.count = action?.payload?.discountList?.count || 0;
            state.discountList.loading = false;
        })
        builder.addCase(getAllPosDiscountList?.rejected, (state, action) => {
            state.discountList.loading = false
            ZenToast({ type: "warning", message: state.error })
        })
        builder.addCase(bulkDeleteDiscountData?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(bulkDeleteDiscountData?.fulfilled, (state, action) => {
            state.loading = false
            state.bulkDeleteResponse = action?.payload
        })
        builder.addCase(bulkDeleteDiscountData?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in bulkDelete discount'
        })
        builder.addCase(checkDuplicatesData.pending, (state) => {
            state.checkDuplicate.loading = true
        })
        builder.addCase(checkDuplicatesData.fulfilled, (state, action: PayloadAction<CheckExistenceRes>) => {
            state.checkDuplicate.loading = false
            state.checkDuplicate.value = action?.payload
        })
        builder.addCase(checkDuplicatesData.rejected, (state, action) => {
            state.checkDuplicate.loading = false
            state.checkDuplicate.error = action?.error?.message ? action?.error?.message : "check duplicate Error "
        })
        builder.addCase(singleDeleteData?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(singleDeleteData?.fulfilled, (state, action: PayloadAction<UpdateRes>) => {
            state.loading = false,
                state.deleteResponse = action?.payload
        })
        builder.addCase(singleDeleteData?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in delete'
        })
        builder.addCase(updateDiscountListStatus?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(updateDiscountListStatus?.fulfilled, (state, action: PayloadAction<UpdateRes>) => {
            state.loading = false
        })
        builder.addCase(updateDiscountListStatus?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in updateStatus'
        })
        builder.addCase(getPosDiscountTypes?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(getPosDiscountTypes?.fulfilled, (state, action: PayloadAction<DiscountTypeRes>) => {
            state.loading = false,
                state.discountType = action?.payload
        })
        builder.addCase(getPosDiscountTypes?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in getDiscountTypes'
        })
        builder.addCase(getPosPropertyValueData?.pending, (state) => {
            state.getProperty.loading = true
        })
        builder.addCase(getPosPropertyValueData?.fulfilled, (state, action: PayloadAction<PropertyResponse>) => {
            state.getProperty.loading = false,
                state.getProperty.value = action?.payload
        })
        builder.addCase(getPosPropertyValueData?.rejected, (state, action) => {
            state.getProperty.loading = false
            state.getProperty.error = action?.error?.message ? action?.error?.message : 'Error in getPropertyValues'
        })
        builder.addCase(getOnePosDiscountData?.pending, (state) => {
            state.getOneDiscount.loading = true
        })
        builder.addCase(getOnePosDiscountData?.fulfilled, (state, action: PayloadAction<GetDiscountDetails>) => {
            state.getOneDiscount.loading = false,
                state.getOneDiscount.value = action?.payload
        })
        builder.addCase(getOnePosDiscountData?.rejected, (state, action) => {
            state.getOneDiscount.loading = false
            state.getOneDiscount.error = action?.error?.message ? action?.error?.message : 'Error in getOneDiscount'
        })



        builder.addCase(addPosDiscount?.pending, (state) => {
            state.addDiscount.loading = true
        })
        builder.addCase(addPosDiscount?.fulfilled, (state, action: PayloadAction<SaveDiscountRes>) => {
            state.addDiscount.loading = false,
                state.addDiscount.value = action?.payload
        })
        builder.addCase(addPosDiscount?.rejected, (state, action) => {
            state.addDiscount.loading = false
            state.addDiscount.error = action?.error?.message ? action?.error?.message : 'Error in add discount'
        })
        builder.addCase(updatePosDiscount?.pending, (state) => {
            state.updateDiscount.loading = true
        })
        builder.addCase(updatePosDiscount?.fulfilled, (state, action: PayloadAction<UpdateDiscountRes>) => {
            state.updateDiscount.loading = false,
                state.updateDiscount.value = action?.payload
        })
        builder.addCase(updatePosDiscount?.rejected, (state, action) => {
            state.updateDiscount.loading = false
            state.updateDiscount.error = action?.error?.message ? action?.error?.message : 'Error in update discount'
        })
    }
})

export default ManualDiscountSlice?.reducer